module.exports = {
  add_more: ' Legg til flere',
  provideFullAddress: 'Du må skrive inn en full adresse',
  dropdownBoth: 'Må utfylle alle felter',
  dropdownDay: 'Vennligst velg ønsket dag',
  dropdownTime: 'Vennligst velg ønsket tidspunkt',
  pictureDescription: 'Legg til bildebeskrivelse (frivillig)',
  changeEmail: 'Ja, endre',
  dontChangeEmail: 'Nei, behold',
  yes: 'Ja',
  no: 'Nei',
  'next-step': 'Gå videre',
  'next-step-wizard': 'Gå videre',
  step: 'Steg',
  off: 'av',
  'first-step-wizard': 'Ja, la oss starte',
  'last-step': 'Få uforpliktende tilbud',
  'go-back': 'Tilbake',
  'go-back-wizard': 'Forrige steg',
  understood: 'Flott, jeg forstår!',
  'company-placeholder': 'Selskap AS',
  'company-autocomplete-label': 'Firmanavn',
  'company-label': 'Firma',
  'address-placeholder': 'Gateadresse 1',
  address_no_number_placeholder: 'Gateadresse',
  'address-label': 'Adresse',
  'address-street-number-label': 'Gatenr.',
  'address-street-number-placeholder': '1A',
  'address-no-street-number-label': 'Adressen har ikke nummer',
  'address-not-found': 'Finner ikke min adresse',
  'address-no-match': 'Ingen treff',
  'address-choose-from': 'Velg blant flere adresser',
  'address-invalid': 'Adressen er ikke gyldig',
  'address-missing': 'Mangler adresse',
  'address-missing-street-number': 'Mangler gatenummer',
  address_alert: 'Har du skrevet inn riktig adresse?',
  address_missing_city: 'Mangler sted',
  'phone-invalid-length': 'Norske nummer må ha 8 siffer.',
  'zip-error': 'Må fylle ut postkode',
  'zip-label': 'Postnummer',
  'zip-does-not-exist': 'Postnr. eksisterer ikke',
  'zip-warning': 'Er du sikker på at du har skrevet riktig postnummer?',
  'zip-autofill-mismatch':
    'Postnummeret du oppga, stemmer ikke med databasen vår. Er du sikker på at det er riktig?',
  zip_placeholder: '1234',
  'name-label': 'Ditt navn',
  'date-format': 'ddmmåå',
  'date-alert-message': 'Har du skrevet riktig fødselsdato?',
  'date-label': 'Dato (6 siffer)',
  'birthdate-label': 'Fødsesdato (6 siffer)',
  'national-identity-label': 'Ditt fødselsnummer',
  'national-identity-placeholder': '11 siffer',
  'national-identity-invalid': 'Ikke gyldig fødselsnummer',
  'national-identity-identical':
    'Medlånetakers fødselsnummer kan ikke være identisk med hovedsøkers',
  'bank-account-label': 'Kontonummer',
  'measuring-id-invalid': 'Ikke gyldig målepunkt id',
  'bank-account-placeholder': '11 siffer',
  'bank-account-invalid': 'Ikke gyldig kontonummer',
  'organization-identity-label': 'Orgnr.',
  'organization-identity-placeholder': '9 siffer',
  'organization-identity-invalid': 'Ikke gyldig orgnr.',
  'date-invalid': 'Ikke gyldig dato',
  'name-placeholder': 'Ola Nordmann',
  'name-invalid': 'Ikke gyldig navn',
  'email-alert-message': 'Har du skrevet riktig e-post?',
  'email-label': 'E-post',
  'email-placeholder': 'navn@domene.no',
  'email-does-not-exist': 'E-posten eksisterer ikke',
  'email-invalid': 'E-post er ikke skrevet riktig',
  email_did_you_mean: 'Mente du',
  'fetching-information': 'Henter information',
  'comment-label': 'Utfyllende info',
  'comment-placeholder': 'Frivillig, f.eks. informasjon om ønsker, behov eller spesielle hensyn.',
  'phone-alert-message': 'Har du skrevet riktig nummer?',
  'phone-label': 'Telefon',
  'phone-invalid': 'Ikke gyldig telefonnummer',
  'phone-must-begin-with-+': 'Må begynne med +',
  'phone-foreign': 'Utenlandsk telefonnummer',
  'phone-placeholder': '12345678',
  'phone-foreign-placeholder-prefix': '+47 ',
  'error-x-numbers': 'Må bestå av --x-- siffer',
  'error-x-letters': 'Må bestå av --x-- tegn',
  'error-min-rooms': 'Må velge minst ett rom',
  'error-min-x-letters': 'Må ha minst --x-- bokstaver',
  'error-min-x-numbers': 'Må bestå av minst --x-- siffer',
  'error-max-x-numbers': 'Må bestå av maksimum --x-- siffer',
  'error-inbetween-numbers': 'Må bestå av --x------y siffer',
  'error-must-consist-of-x-letters': 'Må inneholde minst --x-- bokstaver',
  'error-mandatory': 'Må fylles ut',
  'error-choose': 'Velg minst --x-- alternativ',
  'error-min-age': 'Tilbud gis dessverre kun til kunder over --x-- år',
  'error-must-accept': 'Må aksepteres',
  'error-only-digits': 'Kun tall',
  privacy:
    ' <strong>Personvernet ditt ivaretas:</strong> Vi behandler alle data etter personvernforordningen (GDPR).',
  'privacy-policy':
    '<h4>Personvernpolicy</h4><p>Personvern er svært viktig for oss i --x--. Du som bruker skal være trygg på at informasjonen du fyller ut ikke blir brukt til noe annet enn det du har gitt samtykke til og at den oppbevares sikkert.</p><p>Dataene du fyller inn er minimumet tilbydere behøver for å kunne gi deg konkrete tilbud basert på dine behov. De blir ikke benyttet til noe annet enn å gi deg nettopp slike tilbud i en fornuftig tidsavgrenset periode, basert på dine valg og preferanser for kommunikasjonsform og –tid, der relevant, i tillegg til det nødvendige administrative arbeidet knyttet til dette.</p><p>Dataene behandles av det norske IT-selskapet Nettbureau AS som eier og driver --x--, i tillegg til de aktuelle leverandørene.</p><p>Personopplysninger om deg skal kun behandles for lovlige formål og vil bli slettet eller anonymisert når vi ikke lenger har grunnlag for å behandle dem.</p><p>Nettbureau skal sikre at personopplysninger om deg er tilfredsstillende beskyttet.</p><p>Nettbureau sikrer kommunikasjon med brukerne ved hjelp av kryptering.</p> <p>Les mer i vår <a href="--y--" target="__blank">fullstendige personvernpolicy</a></p>',
  close: 'Lukk',
  error_radio_button: 'Må velge et felt',
  invalid_day: 'Ikke gyldig dato',
  invalid_day_in_month: 'Denne datoen finnes ikke i denne måneden',
  invalid_month: 'Ikke gyldig måned',
  invalid_year: 'Ikke gyldig årstall',
  invalid_country: 'Ikke gyldig land',
  label_birthdate: 'Fødselsdato',
  label_date: 'Dato',
  label_day: 'Dag',
  label_month: 'Måned',
  label_year: 'År',
  locale: 'nb-NB',
  new_locale: 'no-NO',
  missing_date: 'Mangler dato',
  missing_month: 'Mangler måned',
  missing_year: 'Mangler år',
  'datepicker-button': 'Velg dato',
  email_wrong_user_account: 'Er du sikker på at e-post brukerkonto er skrevet korrekt?',
  email_wrong_email_address: 'Er du sikker på at du har skrevet en gyldig e-post adresse?',
  not_valid_municipality: 'Ikke gyldig kommune',
  not_valid_state: '',
  'invalid-file-size': 'Max filstørrelse er',
  'invalid-file-type': 'Denne filtypen støttes ikke. Last opp',
  'drop-files-first': 'Slipp filene her eller',
  'drop-files-last': 'klikk for å velge/ta bilde',
  'vehicle-label': 'Registreringsnummer',
  'vehicle-invalid': 'Registreringsnummeret er ikke riktig',
  'leazard-error-boundary-headline': 'Beklager, noe gikk galt',
  'leazard-error-boundary-description':
    'Vennligst trykk på knappen under for å prøve igjen. Om problemet vedvarer: ',
  'leazard-error-boundary-contact-customer-service': 'Kontakt kundeservice.',
  'leazard-error-boundary-email-subject': 'Skjema feil',
  'leazard-error-boundary-button-text': 'Prøv igjen',
  'sms-verification-label': 'Sms verifikasjon',
  'sms-verification-tinyLabel':
    'Vennligst skriv inn koden som vi nettopp sendte deg via SMS til ditt mobiltelefonnummer: --xx--',
  'sms-verification-error-message': 'Feil kode',
  'sms-verification-code-not-received-first': 'Fikk du ikke en kode? Klikk ',
  'sms-verification-code-not-received-link': 'her',
  'sms-verification-code-not-received-last': ' for å få tilsendt en ny.',
  'sms-verification-code-is-sent-again': 'Koden har blitt sendt på nytt.',
  'sms-verification-code-retry-error':
    'For mange forespørsler. Vennligst vent 30 sekunder før du prøver igjen.',
  'leazard-two-factor-header': 'Straks i mål',
  'leazard-two-factor-help-text':
    'Vi har sendt deg en kode via SMS fra +47 59 44 45 00 for å bekrefte nummeret ditt.',
  'leazard-two-factor-submit': 'Fullfør',
  'leazard-two-factor-label': 'Skriv inn koden for å bekrefte.',
  'leazard-loading-text': 'Behandler opplysningene',
  'accept-terms-of-use': 'Jeg aksepterer --x--, og bekrefter at personopplysningene er korrekte.',
  car_brand: 'Merke',
  car_price: 'Estimert pris',
  car_model: 'Modell',
  car_year: 'Årsmodell',
  car_distance: 'Kilometerstand',
  currency: ' NOK',
  car_warning: 'Endelig pristilbud får du fra bilforhandlere etter å ha fullført skjemaet.',
  estimate_missing: 'Kan ikke estimere pris.',
  'odometer-missing': 'Mangler kilometerstand.',
  'recaptcha-disclaimer': 'Denne nettsiden er beskyttet av reCAPTCHA.',
};
